import { PageDecorated } from 'pages/page';
import React from 'react';
import { ContentBox } from 'components/content-box';
import { downloadVideoSelector } from 'common/selectors/custom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchDownloadVideoRequestAction } from 'common/actions';
import { LoadingSpinner } from 'components/loading-spinner';
import { errorSelector } from 'components/error-handle/selectors';
import { ErrorHandleEnum } from 'components/error-handle/enum';
import { Error404Page, Error500Page } from 'pages/error.pages';
import { format, parseISO } from 'date-fns';
import { compose } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

const UitRegularDownloadPage = ({ downloadVideo, fetchDownloadVideo, error }) => {
  if (error.errorType === ErrorHandleEnum.UIT_REGULAR_DOWNLOAD_PAGE) {
    if (error.errorStatus === 404) {
      return <Error404Page />;
    }
    if (error.errorStatus === 500) {
      return <Error500Page error={error} />;
    }
  }

  if (!downloadVideo) {
    fetchDownloadVideo();
    return (
      <PageDecorated>
        <LoadingSpinner />
      </PageDecorated>
    );
  }

  return (
    <PageDecorated>
      <ContentBox className="ct-uit-download-page">
        <h1>Filme von Union Investment</h1>
        <p>
          Grundsätzlich empfehlen wir unsere Filme über einen HTML-Embed-Code einzubinden. Das hat den Vorteil, dass Sie
          stets automatisch über die aktuellste Filmversion verfügen.
        </p>

        <p>
          Falls Sie nicht über einen HTML-Embed-Code einbinden können, haben Sie hier die Möglichkeit den gewünschten
          Film als Datei herunterzuladen. Bitte beachten Sie dazu die Hinweise im{' '}
          <a
            target="_blank"
            rel="noreferrer nofollow noopener"
            href="https://portal.union-investment.de/documents/20135/6466120/b75fHinweisblatt_regulatorische_Anforderungen_Film+August+2018.pdf/75bc218f-d5e0-08c7-1541-fa53374306ee?download=true"
          >
            Merkblatt
          </a>
          .
        </p>

        <table className="ct-uit-download-page__table">
          <thead className="ct-uit-download-page__table-header">
            <tr>
              <th className="ct-uit-download-page__table-header__item">Datei</th>
              <th className="ct-uit-download-page__table-header__item">Version</th>
              <th className="ct-uit-download-page__table-header__item">Letzte Aktualisierung</th>
              <th className="ct-uit-download-page__table-header__item">Größe in MB</th>
              <th className="ct-uit-download-page__table-header__item">Format</th>
              <th className="ct-uit-download-page__table-header__item">Qualität</th>
            </tr>
          </thead>
          <tbody>
            {downloadVideo &&
              downloadVideo.format
                .filter((video) => video.quality === '1080p' || video.quality === 'original')
                .filter((video) => ['wmv', 'asf', 'mp4'].includes(video.type) || video.quality === 'original')
                .filter((video) => video.link)
                .sort((a, b) => {
                  if (a.quality === 'original') {
                    return -1;
                  } else if (b.quality === 'original') {
                    return 1;
                  } else {
                    return a.type < b.type ? -1 : 1;
                  }
                })
                .map((video, index) => (
                  <tr className="ct-uit-download-page__table-row" key={index}>
                    <td className="ct-uit-download-page__table-row__item">
                      <a href={video.link} target="_blank" rel="noreferrer noopener">
                        {downloadVideo.title}
                      </a>
                    </td>
                    <td className="ct-uit-download-page__table-row__item">{downloadVideo.version}</td>
                    <td className="ct-uit-download-page__table-row__item">
                      {downloadVideo.lastModifiedDate && format(parseISO(downloadVideo.lastModifiedDate), 'dd.MM.yyyy')}
                    </td>
                    <td className="ct-uit-download-page__table-row__item">{Math.round(video.size / 1024 / 1024)}</td>
                    <td className="ct-uit-download-page__table-row__item">
                      {video.type === 'asf' ? 'wmv' : video.type}
                    </td>
                    <td className="ct-uit-download-page__table-row__item">{video.quality}</td>
                  </tr>
                ))}

            <tr>
              <td className="ct-uit-download-page__table__note" colSpan={6}>
                <FontAwesomeIcon className="ct-uit-download-page__table__note__icon" icon={faInfoCircle} />
                <span className="ct-uit-download-page__table__note__text">
                  Zum Herunterladen klicken Sie mit der rechten Maustaste auf die Datei und wählen Sie die Option "Ziel
                  speichern unter...".
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ContentBox>
    </PageDecorated>
  );
};

export const UitRegularDownloadPageDecorated = compose(
  withRouter,
  connect(
    (state) => ({
      downloadVideo: downloadVideoSelector(state),
      error: errorSelector(state),
    }),
    (dispatch, props) => ({
      fetchDownloadVideo: () => dispatch(fetchDownloadVideoRequestAction(props.match.params.videoId)),
    })
  )
)(UitRegularDownloadPage);
